<div class="headerbar-container">
    <p>Goal</p>
    <p>Status</p>
    <p>Progress</p>
    <p>Goal due</p>
    <p>Created by</p>
</div>